module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-city-picker"
  }, [_c('div', {
    attrs: {
      "id": "current_city"
    }
  }, [_c('h3', [_vm._v("I want to learn about:\n      "), _vm._l((_vm.store.state.cityList), function(city) {
    return _c('span', {
      staticClass: "city-name",
      class: {
        selected: city === _vm.store.state.currentCity
      },
      on: {
        "click": function($event) {
          return _vm.store.dispatch('selectCurrentCity', city)
        }
      }
    }, [_vm._v(_vm._s(city))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c2ff89e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityPicker.vue
// module id = 179
// module chunks = 1